import { graphqlRequest } from './graphqlRequest';
import { readFileAsDataUrl } from './uploadToSignedUrl';

const UPLOAD_BOOKING_FILE = `
  mutation UploadBookingFileContent(
    $fileName: String!
    $contentType: String!
    $dataBase64: String!
  ) {
    uploadBookingFileContent(
      fileName: $fileName
      contentType: $contentType
      dataBase64: $dataBase64
    ) {
      key
    }
  }
`;

const MAX_BYTES = 15 * 1024 * 1024;

const TYPES_BY_EXT = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  csv: 'text/csv',
  txt: 'text/plain',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
};

/** MIME type for a file name, from its extension. */
export function contentTypeFor(name, fallback = '') {
  const ext = String(name || '').match(/\.([a-z0-9]+)$/i)?.[1]?.toLowerCase();
  return fallback || (ext && TYPES_BY_EXT[ext]) || 'application/octet-stream';
}

/**
 * Store a File/Blob on the booking file store through the API (no direct
 * browser → S3 PUT, so the bucket needs no CORS rule). Keeps the original
 * file name in the key. Returns the attachment shape the email composer uses.
 */
export async function uploadBookingFile(file, fileName = file?.name || 'file') {
  if (!file) throw new Error('No file to upload');
  if (file.size > MAX_BYTES) throw new Error(`${fileName} must be 15MB or smaller`);
  const contentType = contentTypeFor(fileName, file.type);
  const dataBase64 = await readFileAsDataUrl(file);
  const data = await graphqlRequest(
    UPLOAD_BOOKING_FILE,
    { fileName, contentType, dataBase64 },
    { timeout: 120000 },
  );
  const key = data?.uploadBookingFileContent?.key;
  if (!key) throw new Error(`Failed to upload ${fileName}`);
  return {
    key,
    fileName,
    contentType,
    sizeLabel: `${Math.max(1, Math.round(file.size / 1024))} KB`,
  };
}
